const defaultWriterValue = {
  step: 0,
  template: '',
  intro: '',
  topic: '',
};

export default defaultWriterValue;
